export const presetBgColors = {
	'bg-white': '#ffffff'.toLowerCase(),
	'bg-grey-100': '#f8f8f8'.toLowerCase(),
	'bg-primary-200': '#0002FF'.toLowerCase(),
	'bg-primary-500': '#000273'.toLowerCase(),
	'bg-secondary-300': '#DE75CC'.toLowerCase(),
	'bg-black': '#000000'.toLowerCase(),
};

export const presetTextColors = {
	'text-white': '#ffffff'.toLowerCase(),
	'text-grey-500': '#6A6A6A'.toLowerCase(),
	'text-primary-200': '#0002FF'.toLowerCase(),
	'text-primary-500': '#000273'.toLowerCase(),
	'text-secondary-300': '#DE75CC'.toLowerCase(),
	'text-black': '#000000'.toLowerCase(),
};

function hexToPresetClass(presets: object, hex: string = ''): string|null {
	hex = hex.toLowerCase().trim();
	const keys = Object.keys(presets);
	const values =  Object.values(presets);
	const index = values.indexOf(hex);

	if (index > -1) {
		return keys[index];
	}
	return null;
}

export function hexToBgClass(hex: string = ''): string|null {
	return hexToPresetClass(presetBgColors, hex);
}

export function hexToTextClass(hex: string = ''): string|null {
	return hexToPresetClass(presetTextColors, hex);
}
